import styled from 'styled-components';
import { spacings } from '../../tokens/spacings';
import { theme } from '../../tokens/theme';

export const HomeWrapper = styled.main`
  padding: ${spacings.XXX_LARGE} ${spacings.X_LARGE} ${spacings.X_LARGE};
  display: flex;
  flex-direction: column;
  row-gap: ${spacings.LARGE};
  max-width: 80%;
`;

export const Subtitle = styled.p`
  color: ${theme.light.text.staticIconsDefault};
  margin: 0;
`;

export const Wordmark = styled.img`
  display: block;
  height: ${spacings.XXXX_LARGE};
  margin-bottom: ${spacings.MEDIUM};
  margin-left: ${spacings.X_LARGE};
  width: auto;
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: ${spacings.LARGE};
`;

export const CardRow = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid ${theme.light.ui.background.medium};
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);

  > div {
    flex: 1;
  }
`;

export const CardImage = styled.div`
  min-height: 100%;
  background: ${theme.light.ui.background.light};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  max-width: 30%;
`;
